import { CONTESTS, SEARCH_CONTESTS } from "./actionTypes";

const initialState = {
  contests: [],
  filteredContests: [],
};

export default function (state = initialState, action) {
    switch (action.type) {
      case CONTESTS:
        return {
          ...state,
          contests: action.page === 1 ? action.payload : [...state.contests, ...action.payload],
        };
        case SEARCH_CONTESTS:
      return {
        ...state,
        filteredContests: action.payload.filteredContests,
      };
      default:
        return state;
    }
}
